<template>
  <section class="app-download-panel" :style="themeVariables">
    <div class="download-copy">
      <span>{{ kicker }}</span>
      <h2>{{ title }}</h2>
      <p>{{ description }}</p>
    </div>
    <div class="download-buttons">
      <component
        :is="iosUrl ? 'a' : 'div'"
        :href="iosUrl || undefined"
        :target="iosUrl ? '_blank' : undefined"
        :rel="iosUrl ? 'noopener noreferrer' : undefined"
        class="download-button"
        :class="{disabled: !iosUrl}"
      >
        <span class="platform-icon">
          <img :src="appleIcon" alt="iOS">
        </span>
        <div><small>{{ iosLabel }}</small><strong>{{ iosUrl ? iosDownloadText : comingSoon }}</strong></div>
        <span class="arrow">{{ iosUrl ? '↗' : '—' }}</span>
      </component>
      <component
        :is="androidUrl ? 'a' : 'div'"
        :href="androidUrl || undefined"
        :target="androidUrl ? '_blank' : undefined"
        :rel="androidUrl ? 'noopener noreferrer' : undefined"
        class="download-button"
        :class="{disabled: !androidUrl}"
      >
        <span class="platform-icon">
          <img :src="androidIcon" alt="Android">
        </span>
        <div><small>{{ androidLabel }}</small><strong>{{ androidUrl ? androidDownloadText : comingSoon }}</strong></div>
        <span class="arrow">{{ androidUrl ? '↗' : '—' }}</span>
      </component>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppDownloadPanel',
  props: {
    isEnglish: { type: Boolean, default: false },
    productName: { type: String, required: true },
    accent: { type: String, default: '#526de8' },
    glow: { type: String, default: 'rgba(82, 109, 232, .16)' },
    iosUrl: { type: String, default: '' },
    androidUrl: { type: String, default: '' },
    iosText: { type: String, default: '' },
    androidText: { type: String, default: '' }
  },
  data() {
    return {
      appleIcon: require('@/assets/images/phone/apple.png'),
      androidIcon: require('@/assets/images/phone/android.png')
    };
  },
  computed: {
    kicker() { return this.isEnglish ? `GET ${this.productName.toUpperCase()}` : `获取 ${this.productName}`; },
    title() { return this.isEnglish ? `Download ${this.productName}` : `下载 ${this.productName}`; },
    hasDownloadUrl() { return Boolean(this.iosUrl || this.androidUrl); },
    description() {
      if (this.hasDownloadUrl) {
        return this.isEnglish
          ? 'Choose the version for your device and download the latest app package.'
          : '请选择适合当前设备的版本，下载最新 App 安装包。';
      }

      return this.isEnglish
        ? 'The iOS and Android versions are being prepared. Download links will be available here once released.'
        : 'iOS 与 Android 版本正在准备中，正式开放后可在这里获取对应版本。';
    },
    iosLabel() { return this.isEnglish ? 'iOS DOWNLOAD' : 'iOS 下载'; },
    androidLabel() { return this.isEnglish ? 'ANDROID DOWNLOAD' : 'Android 下载'; },
    iosDownloadText() { return this.iosText || 'iOS'; },
    androidDownloadText() { return this.androidText || 'Android'; },
    comingSoon() { return this.isEnglish ? 'Coming Soon' : '即将开放'; },
    themeVariables() { return { '--app-accent': this.accent, '--app-glow': this.glow }; }
  }
};
</script>

<style lang="stylus" scoped>
.app-download-panel
  max-width 1320px
  margin 0 auto
  padding 84px 70px
  display flex
  align-items center
  justify-content space-between
  gap 52px
  position relative
  color #14213d
  border-top 1px solid rgba(65,83,140,.1)
  &::before
    content ''
    position absolute
    width 330px
    height 330px
    right 8%
    top -90px
    border-radius 50%
    background var(--app-glow)
    filter blur(80px)
.download-copy
  position relative
  max-width 540px
  > span
    color var(--app-accent)
    font-size 12px
    font-weight 750
    letter-spacing .14em
  h2
    margin 13px 0 14px
    padding 0
    color #14213d
    font-size clamp(34px,4vw,52px)
    line-height 1.15
    letter-spacing -.04em
  p
    margin 0
    color #687492
    font-size 16px
    line-height 1.8
.download-buttons
  position relative
  width min(100%,430px)
  display flex
  flex-direction column
  gap 13px
.download-button
  display grid
  grid-template-columns 46px 1fr auto
  align-items center
  gap 15px
  padding 17px 20px
  color #243354
  border 1px solid rgba(74,95,160,.16)
  border-radius 18px
  background rgba(255,255,255,.9)
  box-shadow 0 14px 36px rgba(35,53,105,.08)
  text-decoration none
  transition transform .25s ease,border-color .25s ease,box-shadow .25s ease
  &[href]:hover
    transform translateX(5px)
    border-color var(--app-accent)
    box-shadow 0 18px 44px rgba(35,53,105,.13)
  &.disabled
    background rgba(247,249,253,.85)
    box-shadow none
  .platform-icon
    width 44px
    height 44px
    display flex
    align-items center
    justify-content center
    border-radius 22px
    background linear-gradient(180deg, #24292f 0%, #181c1f 100%)
    box-shadow inset 0 0 0 1px rgba(255,255,255,.08), 0 8px 18px rgba(0,0,0,.16)
    flex none

    img
      width 20px
      height 20px
      object-fit contain
  div
    display flex
    flex-direction column
    gap 3px
  small
    color #8793aa
    font-size 10px
    letter-spacing .06em
  strong
    color #253454
    font-size 17px
  .arrow
    color var(--app-accent)
    font-size 19px
@media (max-width: 780px)
  .app-download-panel
    padding 68px 20px
    flex-direction column
    align-items flex-start
  .download-buttons
    width 100%
</style>
